<template>
  <div>
    <ul v-if="hasVersions">
      <li v-for="(version, index) in orderedVersions" :key="index">
        {{ version.message }}
      </li>
    </ul>
    <p v-else>Sem histórico registado até ao momento</p>
  </div>
</template>

<script>
export default {
  name: 'DiaryVersionLog',
  props: {
    versions: {
      type: Array,
      required: true
    }
  },
  computed: {
    orderedVersions() {
      return this.versions;
    },
    hasVersions() {
      return Array.isArray(this.versions) && this.versions.length > 0;
    }
  }
}
</script>

<style scoped>
ul {
  padding-left: 1rem;
}
li {
  margin-bottom: 0.5rem;
}
</style>
